export default __webpack_public_path__ + "static/media/logo_HDM_white.37a93925.svg";